import { useTranslation } from 'react-i18next';
import appicon from '../../assets/appicon_raw.svg';
import './BIEASESIcon.css'

function BIEASESIcon() {
    const { t } = useTranslation();
    return (<>
        <div className='logo_container'>
            <div className='title-banner'>
                {t('scan_qr')}
            </div>
            <div>
                <img className='logo' src={appicon} alt="BIEASES App Icon" />
            </div>
        </div>
    </>)
}

export default BIEASESIcon;